import React, { useContext, useState } from "react";
import "./Product_Description.css";
import { Accordion } from "react-bootstrap";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { faPen, faShoppingBag } from "@fortawesome/free-solid-svg-icons";
import View_cart_modal from "../../common_components/view_cart_modal/View_cart_modal";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import parse from "html-react-parser";
import { AddToCartLuxury } from "../../../utils/luxuryapis/addToCart/addToCart";
const Product_Description = ({
  product,
  variant,
  setVariant,
  setSelectedImage,
  setSubVariant,
  subVariant,
}) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { IMG_URL, signin } = useContext(Context);

  const mrp = Number(subVariant?.mrp || 0);
  const price = Number(subVariant?.price || 0);
  const discount = mrp > 0 ? Math.round(((mrp - price) / mrp) * 100) : 0;

  const createAddTocart = async (product, variant, subVariant) => {
    const data = {
      product_id: product?.id,
      variant_id: variant?.id,
      quantity_id: subVariant?.id,
      quantity: 1,
    };
    let res = await AddToCartLuxury(data);
    if (res) {
      setShow(true);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  return (
    <>
      <section className="Product_Description">
        <div className="white_card">
          <div className="top_div">
            <p className="product_name">{product?.name}</p>
            <div className="price_div">
              <div className="d-flex gap-3">
                <p className="mrp_text">
                  MRP <span>₹{subVariant?.mrp}</span>
                </p>
                <p className="selling_price">
                  Selling Price: ₹ {subVariant?.price}
                </p>
              </div>
              <p className="discount_text">{discount}% Discount</p>
            </div>
          </div>

          <div className="description_div">
            <div className="colour_div">
              <p className="left_text">Colour</p>
              <p className="colour_text">{variant?.v_name}</p>
            </div>
            <div className="small_img_holder">
              {product?.product_variants?.map((val) => (
                <div
                  key={val.id}
                  className="small_div"
                  onClick={() => {
                    setVariant(val);
                    setSelectedImage(IMG_URL + val?.product_images[0]?.image);
                  }}
                >
                  <img
                    src={IMG_URL + val?.product_images?.[0]?.image}
                    className="small_img"
                    alt="variant"
                  />
                </div>
              ))}
            </div>

            <div className="note_div">
              <img
                src="/assest/luxury_images/other/star.png"
                className="star_img"
              />
              <p className="note_text">
                Earning or redemption of Mittal Coins are not applicable on{" "}
                <br />
                <b>Gold and Silver products</b>
              </p>
            </div>

            <div className="variant_div">
              <Accordion className="info_accordion">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Please Choose The Variant</Accordion.Header>
                  <Accordion.Body>
                    <div className="main_div">
                      {variant?.product_quantities?.map((item, index) => {
                        return (
                          <div
                            className={`inner_div${
                              item?.id === subVariant?.id ? " active" : ""
                            }`}
                            onClick={() => setSubVariant(item)}
                          >
                            <p className="inner_text">{item?.name}</p>
                          </div>
                        );
                      })}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>

            <div className="btn_holder">
              {Number(subVariant?.unit) <= 0 ? (
                <button
                  style={{
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    cursor: "not-allowed",
                  }}
                  disabled
                >
                  Out Of Stock
                </button>
              ) : (
                <>
                  <Purple_Btn
                    btnText={"Add To Cart"}
                    onClick={() =>
                      createAddTocart(product, variant, subVariant)
                    }
                    leftIcon={faShoppingBag}
                  />
                  {product?.product_detail?.customize_status === 1 && (
                    <Purple_Btn
                      btnText={"Customise Now"}
                      leftIcon={faPen}
                      onClick={() => {
                        if (signin) {
                          navigate(
                            `/luxury/product-customisation/${product?.id}?variant_id=${variant?.id}&subVariant_id=${subVariant?.id}`,
                            {
                              state: { showSecondForm: true },
                            },
                          );
                        } else {
                          navigate("/login");
                        }
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </div>

          <div className="footer_text_div">
            {" "}
            {typeof product?.product_detail?.about === "string"
              ? parse(product?.product_detail?.about)
              : ""}
          </div>
        </div>

        <div className="white_card card2">
          <div className="details_inner_div">
            <Accordion className="details_accordion" defaultActiveKey="0">
              {/* {["Product Details", "Care", "Shipping", "Gifting"].map(
                (item, index) => ( */}
              <Accordion.Item eventKey={0} key={0}>
                <Accordion.Header>Product Details</Accordion.Header>

                <Accordion.Body>
                  <div className="main_div">
                    <div className="inner_text_div">
                      <p className="inner_desc_text">
                        {typeof product?.product_detail?.about === "string"
                          ? parse(product?.product_detail?.about)
                          : ""}
                      </p>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey={1} key={1}>
                <Accordion.Header>Care</Accordion.Header>

                <Accordion.Body>
                  <div className="main_div">
                    <div className="inner_text_div">
                      <p className="inner_desc_text">
                        {" "}
                        {typeof product?.product_detail?.benifits === "string"
                          ? parse(product?.product_detail?.benifits)
                          : ""}
                      </p>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey={2} key={2}>
                <Accordion.Header>Shipping</Accordion.Header>

                <Accordion.Body>
                  <div className="main_div">
                    <div className="inner_text_div">
                      <p className="inner_desc_text">
                        {typeof product?.product_detail?.storage === "string"
                          ? parse(product?.product_detail?.storage)
                          : ""}
                      </p>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey={3} key={3}>
                <Accordion.Header>Gifting</Accordion.Header>

                <Accordion.Body>
                  <div className="main_div">
                    <div className="inner_text_div">
                      <p className="inner_desc_text">
                        {" "}
                        {product?.short_description}
                      </p>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="footer_div">
              {product?.reference_no && (<p className="rerfence">Product reference: {product?.reference_no}</p>)}
              
              <p className="rerfence">
                Like to know more?{" "}
                <Link to={"/luxury/add-address"}>Contact Customer Service</Link>{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
      <View_cart_modal
        show={show}
        handleClose={() => setShow(false)}
        handleViewCart={() => alert("Go to cart page")}
      />
    </>
  );
};

export default Product_Description;
